import { render, staticRenderFns } from "./ConfirmePixView.vue?vue&type=template&id=0b495022&scoped=true&"
import script from "./ConfirmePixView.vue?vue&type=script&lang=js&"
export * from "./ConfirmePixView.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmePixView.vue?vue&type=style&index=0&id=0b495022&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b495022",
  null
  
)

export default component.exports